module.exports = __webpack_public_path__ + "static/media/guiaAzul.ad6e1a27.png";